import * as actions from './actions';

const initialState = {
    folders: [],
    error: null,
    initial: false,
    loading: false,
};

export default function brevoFoldersReducer(state = initialState, action) {
    switch (action.type) {
        case actions.FETCH_BREVO_FOLDERS.REQUEST:
            return { ...state, loading: true, error: null };

        case actions.FETCH_BREVO_FOLDERS.SUCCESS:
            return { ...state, initial: true, folders: action.payload.data, loading: false, error: null };

        case actions.FETCH_BREVO_FOLDERS.FAILURE:
            return { ...state, initial: false, loading: false, error: action.payload.error };

        default:
            return state;
    }
}